if (!customElements.get('media-complementary')) {
  customElements.define(
    'media-complementary',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();

        // Resize observer to track height changes
        this.resizeObserver = new ResizeObserver(() => {
          this.updateHeight();
        });

        // Mutation observer to track DOM/content changes inside
        this.mutationObserver = new MutationObserver(() => {
          this.observeImages();
        });

        this.imageLoadListeners = [];
      }

      connectedCallback() {
        // Start observing height changes of this element
        this.resizeObserver.observe(this);

        // Start observing DOM changes inside this element
        this.mutationObserver.observe(this, { childList: true, subtree: true });

        // Initial update
        this.updateHeight();
        this.observeImages();
      }

      disconnectedCallback() {
        this.resizeObserver.disconnect();
        this.mutationObserver.disconnect();

        // Clean up old listeners
        this.imageLoadListeners.forEach(({ img, handler }) => {
          img.removeEventListener('load', handler);
        });
        this.imageLoadListeners = [];
      }

      updateHeight() {
        const height = this.offsetHeight;
        this.style.setProperty('--media-complementary-height', `${height}px`);
      }

      observeImages() {
        // Remove old listeners
        this.imageLoadListeners.forEach(({ img, handler }) => {
          img.removeEventListener('load', handler);
        });
        this.imageLoadListeners = [];

        // Track new image load events
        const images = this.querySelectorAll('img');
        images.forEach(img => {
          const handler = () => this.updateHeight();
          img.addEventListener('load', handler);
          this.imageLoadListeners.push({ img, handler });

          // If image is already loaded, update immediately
          if (img.complete) {
            this.updateHeight();
          }
        });
      }
    }
  );
}
